import {
  Box,
  Button,
  Checkbox,
  Heading,
  Icon,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Flex,
  Spinner,
  useToast,
  useDisclosure,
  List,
  ListItem,
  ListIcon,
} from '@chakra-ui/react'
import { useContext, useEffect, useState } from 'react'
import { RiAddLine, RiCheckLine, RiDeleteBin6Line, RiPencilLine } from 'react-icons/ri'
import { useMutation } from 'react-query'
import { Modal } from '../../components/Modal'
import { Pagination } from '../../components/Pagination'
import { Provider } from '../../Interfaces/provider'
import { api } from '../../services/api'
import { useProviders } from '../../services/hooks/useProviders'
import { Link } from 'react-router-dom'
import { SearchContext } from '../../context/SearchContext'

export function Prodivders() {
  const toast = useToast()

  const [page, setPage] = useState(1)

  const { queryContextParams, clearQuery } = useContext(SearchContext)

  const { data, isLoading, isFetching, error, refetch } = useProviders<Provider[]>(false, {
    page,
    ...queryContextParams,
  })

  const { isOpen, onOpen, onClose } = useDisclosure()

  const [currentProvider, setCurrentProvider] = useState<Provider>()

  useEffect(() => {
    refetch()
  }, [queryContextParams])

  useEffect(() => {
    return () => {
      clearQuery()

      refetch()
    }
  }, [])

  const handleRemoveButton = () => {
    if (currentProvider) removeProvider.mutateAsync(currentProvider)

    onClose()
  }

  const removeProvider = useMutation(
    async (provider: Provider) => {
      const response = await api.delete(`providers/${provider.id}`)

      if (response) {
        toast({ description: 'Removido com sucesso', status: 'success' })
        refetch()
      }

      onClose()
      return response.data
    },
    {
      onError: ({ response }) => {
        const errorList = response.data.errors

        const toastOptions = errorList.map((err) => ({ description: err.message, status: 'error' }))
        toastOptions.forEach((t) => {
          toast(t)
        })
      },
    },
  )

  const handleModalOpen = (provider) => {
    setCurrentProvider(provider)

    onOpen()
  }

  return (
    <Box flex="1" borderRadius="8" bg="gray.800" p="8">
      <Flex mb="8" justifyContent="space-between" align="center">
        <Heading size="lg" fontWeight="normal">
          Fornecedores
          {!isLoading && isFetching && <Spinner size="sm" color="gray.500" ml="4" />}
        </Heading>

        <Button
          as={Link}
          to="/providers/create"
          size="sm"
          fontSize="sm"
          colorScheme="pink"
          leftIcon={<Icon as={RiAddLine} fontSize="20" />}>
          Criar Novo
        </Button>
      </Flex>

      {isLoading ? (
        <Flex justify="center">
          <Spinner />
        </Flex>
      ) : error ? (
        <Flex justify="center">
          <Text>Falha ao obter os fornecedores</Text>
        </Flex>
      ) : (
        <Table colorScheme="whiteAlpha">
          <Thead>
            <Tr>
              <Th px={['4', '4', '6']} color="gray.300" width="8">
                <Checkbox colorScheme="pink" />
              </Th>
              <Th>Nome</Th>
              <Th>Telefone</Th>
              <Th>E-mail</Th>
              <Th width="4" />
              <Th width="4" />
            </Tr>
          </Thead>
          <Tbody>
            {data?.providers.map((provider: Provider) => {
              return (
                <Tr key={provider.id}>
                  <Td px={['4', '4', '6']}>
                    <Checkbox colorScheme="pink" />
                  </Td>
                  <Td>
                    <Box>
                      <Text fontWeight="bold">{provider.name}</Text>
                      <Text fontSize="small" color="gray.300">
                        {provider.cnpj}
                      </Text>
                    </Box>
                  </Td>

                  <Td>{provider.phone}</Td>
                  <Td>{provider.email}</Td>
                  <Td>
                    <Button
                      as={Link}
                      to={`/providers/edit/${provider.id}`}
                      size="sm"
                      fontSize="sm"
                      colorScheme="purple"
                      leftIcon={<Icon as={RiPencilLine} />}>
                      Editar
                    </Button>
                  </Td>
                  <Td>
                    <Button
                      onClick={() => handleModalOpen(provider)}
                      size="sm"
                      fontSize="sm"
                      colorScheme="red"
                      leftIcon={<Icon as={RiDeleteBin6Line} />}>
                      Remover
                    </Button>
                  </Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      )}

      <Pagination totalCountOfRegisters={data?.totalCount} currentPage={page} onPageChange={setPage} />

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        title="Remover Fornecedor"
        buttonTitle="Remover"
        buttonAction={handleRemoveButton}>
        <List spacing={3}>
          <ListItem>
            <ListIcon as={RiCheckLine} color="green.500" />
            {`Nome: ${currentProvider?.name}`}
          </ListItem>
          <ListItem>
            <ListIcon as={RiCheckLine} color="green.500" />
            {`CNPJ: ${currentProvider?.cnpj}`}
          </ListItem>
        </List>
      </Modal>
    </Box>
  )
}
